import { render, staticRenderFns } from "./travel-staytion.vue?vue&type=template&id=442dfc4a&scoped=true&"
import script from "./travel-staytion.vue?vue&type=script&lang=js&"
export * from "./travel-staytion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442dfc4a",
  null
  
)

export default component.exports